import { getGlobalSearchInput } from 'gcs-common/slices/administration/globalSearch/globalSearchSelectors';
import { getTenants, getTenantsPaginationResult } from 'gcs-common/slices/administration/tenants/tenantsSelectors';
import { fetchTenants } from 'gcs-common/slices/administration/tenants/tenantsThunks';
import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SORT_ORDER } from '../../../../constants/sortConstants';
import detailsIcon from '../../../../img/arrow.svg';
import PaginatedTable from '../../../PaginatedTable/PaginatedTable';

const columns = [
  {
    Header: 'Name',
    accessor: 'friendlyName',
  },
];

const TenantTable = ({ onTenantSelected, tenantsLoading }) => {
  const tenants = useSelector(getTenants);
  const tenantsPagination = useSelector(getTenantsPaginationResult);
  const globalSearchInput = useSelector(getGlobalSearchInput);

  const dispatch = useDispatch();

  const accessorToBeSorted = columns.find((element) => element.Header).accessor;
  const [sortedColumnId, setSortedColumnId] = useState(accessorToBeSorted);
  const [sortOrder, setSortOrder] = useState(SORT_ORDER.ASCENDING);

  const loadTenants = useCallback(
    (pageIndex, pageSize, searchQuery) => {
      dispatch(
        fetchTenants({
          pageIndex,
          pageSize,
          searchQuery,
          sortOrder,
          sortedColumnId,
        }),
      );
    },
    [dispatch, sortOrder, sortedColumnId],
  );

  return (
    <PaginatedTable
      onRowSelected={onTenantSelected}
      data={tenants}
      columns={columns}
      onPaginationChanged={loadTenants}
      searchInput={globalSearchInput}
      pagination={tenantsPagination}
      sortOrder={sortOrder}
      setSortOrder={setSortOrder}
      sortedColumnId={sortedColumnId}
      setSortedColumnId={setSortedColumnId}
      sortIsLoading={tenantsLoading}
      renderActions={() => <img alt="details-icon" src={detailsIcon} />}
    />
  );
};

TenantTable.propTypes = {
  onTenantSelected: PropTypes.func.isRequired,
  tenantsLoading: PropTypes.bool.isRequired,
};

export default TenantTable;
